/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Une échéance de l'échéancier (détail chargé à la demande).
 * @export
 * @interface InstallmentDetailDto
 */
export interface InstallmentDetailDto {
    /**
     * Type de quittance, déjà libellé par le back : « Comptant », « Terme », « Sinistre » ou « Résiliation ». Chaîne prête à afficher, aucun code à traduire — un contrat nouvellement souscrit est toujours en « Comptant ».
     * @type {string}
     * @memberof InstallmentDetailDto
     */
    receiptType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstallmentDetailDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof InstallmentDetailDto
     */
    number: number;
    /**
     * 
     * @type {Date}
     * @memberof InstallmentDetailDto
     */
    dueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof InstallmentDetailDto
     */
    withdrawalDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof InstallmentDetailDto
     */
    amount: number;
    /**
     * PLANIFIE | TRANSMIS | PAYE | IMPAYE | REJETE | ANNULE
     * @type {string}
     * @memberof InstallmentDetailDto
     */
    statusCode: string;
    /**
     * 
     * @type {string}
     * @memberof InstallmentDetailDto
     */
    statusLabel: string;
    /**
     * 
     * @type {number}
     * @memberof InstallmentDetailDto
     */
    attempts: number;
    /**
     * 
     * @type {string}
     * @memberof InstallmentDetailDto
     */
    rejectLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstallmentDetailDto
     */
    rejectCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstallmentDetailDto
     */
    lastError?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstallmentDetailDto
     */
    rum?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstallmentDetailDto
     */
    reference?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InstallmentDetailDto
     */
    purePremium?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InstallmentDetailDto
     */
    tax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InstallmentDetailDto
     */
    fees?: number | null;
}

/**
 * Check if a given object implements the InstallmentDetailDto interface.
 */
export function instanceOfInstallmentDetailDto(value: object): value is InstallmentDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('statusLabel' in value) || value['statusLabel'] === undefined) return false;
    if (!('attempts' in value) || value['attempts'] === undefined) return false;
    return true;
}

export function InstallmentDetailDtoFromJSON(json: any): InstallmentDetailDto {
    return InstallmentDetailDtoFromJSONTyped(json, false);
}

export function InstallmentDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstallmentDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'receiptType': json['receiptType'] == null ? undefined : json['receiptType'],
        'id': json['id'],
        'number': json['number'],
        'dueDate': (new Date(json['dueDate'])),
        'withdrawalDate': json['withdrawalDate'] == null ? undefined : (new Date(json['withdrawalDate'])),
        'amount': json['amount'],
        'statusCode': json['statusCode'],
        'statusLabel': json['statusLabel'],
        'attempts': json['attempts'],
        'rejectLabel': json['rejectLabel'] == null ? undefined : json['rejectLabel'],
        'rejectCode': json['rejectCode'] == null ? undefined : json['rejectCode'],
        'lastError': json['lastError'] == null ? undefined : json['lastError'],
        'rum': json['rum'] == null ? undefined : json['rum'],
        'reference': json['reference'] == null ? undefined : json['reference'],
        'purePremium': json['purePremium'] == null ? undefined : json['purePremium'],
        'tax': json['tax'] == null ? undefined : json['tax'],
        'fees': json['fees'] == null ? undefined : json['fees'],
    };
}

export function InstallmentDetailDtoToJSON(json: any): InstallmentDetailDto {
    return InstallmentDetailDtoToJSONTyped(json, false);
}

export function InstallmentDetailDtoToJSONTyped(value?: InstallmentDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'receiptType': value['receiptType'],
        'id': value['id'],
        'number': value['number'],
        'dueDate': ((value['dueDate']).toISOString()),
        'withdrawalDate': value['withdrawalDate'] == null ? undefined : ((value['withdrawalDate'] as any).toISOString()),
        'amount': value['amount'],
        'statusCode': value['statusCode'],
        'statusLabel': value['statusLabel'],
        'attempts': value['attempts'],
        'rejectLabel': value['rejectLabel'],
        'rejectCode': value['rejectCode'],
        'lastError': value['lastError'],
        'rum': value['rum'],
        'reference': value['reference'],
        'purePremium': value['purePremium'],
        'tax': value['tax'],
        'fees': value['fees'],
    };
}

